var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jians"},[_c('img',{attrs:{"src":"img/jians.png"}}),_c('div',{staticClass:"jianstext"},[_c('span',[_vm._v("—正在建设中—")])])])
}]

export { render, staticRenderFns }